
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest/[contestUuid]/entries/overall",
      function () {
        return require("private-next-pages/contest/[contestUuid]/entries/overall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest/[contestUuid]/entries/overall"])
      });
    }
  